/* global rostiZoomInfoConfig */
/**
 * Consent-gated loader for the ZoomInfo script (WebSights, FormComplete, Chat, Schedule).
 *
 * ZoomInfo's tag sets a first-party visitor cookie (_zitok) and identifies the visitor's
 * company, so under GDPR it may only run once the visitor has accepted the matching cookie
 * category. Rather than printing ZoomInfo's snippet directly, we ask CookieYes for the current
 * consent state and only inject the tag when the category is accepted. Without CookieYes on
 * the page nothing loads, which is the safe default.
 */
class ZoomInfoLoader {
	constructor( config = {} ) {
		this.projectKey = typeof config.projectKey === 'string' ? config.projectKey : '';
		this.scriptUrl = typeof config.scriptUrl === 'string' ? config.scriptUrl : '';
		this.category = typeof config.category === 'string' ? config.category : 'analytics';
		this.loaded = false;
	}

	/**
	 * Hook into CookieYes and load straight away if consent is already stored.
	 */
	init() {
		if ( ! this.projectKey || ! this.scriptUrl ) {
			return;
		}

		// Fired by CookieYes when the visitor accepts, rejects or changes their preferences.
		document.addEventListener( 'cookieyes_consent_update', () => this.maybeLoad() );
		// Fired by the CookieYes web app script once the banner has initialised.
		document.addEventListener( 'cookieyes_banner_load', () => this.maybeLoad() );

		// Returning visitors already have consent stored. CookieYes runs synchronously in the head before us, so its API is ready.
		this.maybeLoad();
	}

	/**
	 * Whether CookieYes reports the configured category as accepted.
	 *
	 * @return {boolean} True when consent has been given.
	 */
	hasConsent() {
		if ( typeof window.getCkyConsent !== 'function' ) {
			return false;
		}

		const consent = window.getCkyConsent();

		return Boolean( consent && consent.categories && consent.categories[ this.category ] === true );
	}

	/**
	 * Inject the ZoomInfo tag once, and only with consent.
	 *
	 * Equivalent to the de-obfuscated snippet ZoomInfo supplies: set window.ZIProjectKey and append zi-tag.js.
	 */
	maybeLoad() {
		if ( this.loaded || ! this.hasConsent() ) {
			return;
		}

		this.loaded = true;
		window.ZIProjectKey = this.projectKey;

		const script = document.createElement( 'script' );
		script.type = 'text/javascript';
		script.async = true;
		script.src = this.scriptUrl;

		( document.body || document.head ).appendChild( script );
	}
}

new ZoomInfoLoader( typeof rostiZoomInfoConfig !== 'undefined' ? rostiZoomInfoConfig : {} ).init();
